
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {NntTagCollection} from '@/model/collection/NntTagCollection'
import {FilterNntTagSchema} from '@/schema/resource/NntTag/FilterNntTagSchema'

@Component
export default class FilterNntTag extends Vue {
  @Prop({type: Object, required: true}) collection!: NntTagCollection

  schema = new FilterNntTagSchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = []

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryAsPage())
  }
}
